import { render, staticRenderFns } from "./salesInvoice.vue?vue&type=template&id=d4651cc8&scoped=true&"
import script from "./salesInvoice.vue?vue&type=script&lang=js&"
export * from "./salesInvoice.vue?vue&type=script&lang=js&"
import style0 from "./salesInvoice.vue?vue&type=style&index=0&id=d4651cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4651cc8",
  null
  
)

export default component.exports